import { LocationStoreProvider } from '@/components/tabs/location-store-context';
import { Region } from '@/components/region';
import { SeoMeta } from '@/components/seo-meta';
import { readPageLocationName } from '@/lib/page-location';
import type { ContentPillarPageRouteData } from '@/content-routes/types';
import { fallback as pillarNavigationFallback } from '@/components/pillar-navigation/fallback';

export function ContentPillarPageRoute({ data }: { data: ContentPillarPageRouteData }) {
    const title = data.page.name || data.pageId;
    const description = data.page.description;
    const locationName = readPageLocationName(data.page) ?? null;

    return (
        <>
            <SeoMeta
                pageTitle={data.page.pageTitle}
                pageDescription={data.page.pageDescription}
                title={title}
                description={description || undefined}
                openGraph={{
                    type: 'website',
                    url: data.pageUrl,
                }}
            />
            <LocationStoreProvider store={null} locationName={locationName}>
                <Region
                    key={`${data.pageId}:pillarNavigation`}
                    page={data.page}
                    regionId="pillarNavigation"
                    fallbackElement={pillarNavigationFallback()}
                />
                <Region key={`${data.pageId}:content`} page={data.page} regionId="content" />
            </LocationStoreProvider>
        </>
    );
}
